import React from 'react';
import { BalanceCardSkeleton, ExpenseCardSkeleton } from './Skeleton';

/**
 * Dashboard Skeleton Loader
 * Shows instantly while data loads in background
 * Improves perceived performance
 */
const DashboardSkeleton: React.FC = () => {
  return (
    <div style={{ padding: '16px', paddingBottom: '100px' }}>
      {/* Balance Card Skeleton */}
      <BalanceCardSkeleton />

      {/* Expense Cards Skeleton */}
      <div style={{ marginTop: '24px' }}>
        <ExpenseCardSkeleton />
        <ExpenseCardSkeleton />
        <ExpenseCardSkeleton />
      </div>
    </div>
  );
};

export default DashboardSkeleton;

